import { useEffect, useState } from "react";

/** Ora e data sempre sotto gli occhi: in servizio nessuno tira fuori il telefono per guardare l'ora. */
export const Orologio = () => {
  const [ora, setOra] = useState(new Date());

  useEffect(() => {
    const i = setInterval(() => setOra(new Date()), 15000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="shrink-0 text-right leading-tight" data-testid="orologio">
      <p className="font-num text-sm font-bold tabular-nums sm:text-base" data-testid="orologio-ora">
        {ora.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}
      </p>
      <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400" data-testid="orologio-data">
        {ora.toLocaleDateString("it-IT", { weekday: "short", day: "2-digit", month: "2-digit" })}
      </p>
    </div>
  );
};
